import { render, staticRenderFns } from "./DocumentPartRules.js.vue?vue&type=template&id=bdac6ce4&scoped=true"
import script from "./DocumentPartRules.js.vue?vue&type=script&lang=js"
export * from "./DocumentPartRules.js.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdac6ce4",
  null
  
)

export default component.exports